export default __webpack_public_path__ + "static/media/trendimage.0522851d.svg";